/* expressionWalkers.js */

/**
 * @module expressionWalkers
 *
 * Shared tree recursion for the JSON-edit-pane expression validators. The
 * traversal shape (group recursion + leaf visiting, with JSON-pointer
 * bookkeeping) is identical across validators; only the per-leaf check differs,
 * so each validator passes its own `onLeaf` callback.
 */
const _ = require("lodash");

/**
 * Walk a MongoDB-form expression (`{$and|$or: [...]}` groups, `{<field>: <op>}`
 * leaves). `onLeaf(fieldName, operatorObject, leafPointer)` fires once per
 * field of each leaf object.
 */
const walkMongoLeaves = (expression, pointer, onLeaf) => {
    if (!_.isObject(expression) || _.isArray(expression)) {
        return;
    }
    if (_.isArray(expression.$and)) {
        expression.$and.forEach((sub, idx) =>
            walkMongoLeaves(sub, `${pointer}/$and/${idx}`, onLeaf)
        );
        return;
    }
    if (_.isArray(expression.$or)) {
        expression.$or.forEach((sub, idx) => walkMongoLeaves(sub, `${pointer}/$or/${idx}`, onLeaf));
        return;
    }
    _.each(expression, (operatorObject, fieldName) => onLeaf(fieldName, operatorObject, pointer));
};

/**
 * Walk a queryBuilder-form expression (`{condition, rules:[...]}` groups, leaf
 * objects otherwise). `onLeaf(leaf, leafPointer)` fires once per leaf.
 */
const walkQueryBuilderLeaves = (expression, pointer, onLeaf) => {
    if (!_.isObject(expression) || _.isArray(expression)) {
        return;
    }
    if (expression.condition && _.isArray(expression.rules)) {
        expression.rules.forEach((sub, idx) =>
            walkQueryBuilderLeaves(sub, `${pointer}/rules/${idx}`, onLeaf)
        );
        return;
    }
    onLeaf(expression, pointer);
};

module.exports = {walkMongoLeaves, walkQueryBuilderLeaves};
